import * as React from 'react';
import * as styles from './styles.css';

export interface IWrapperProps {
  children: React.ReactNode | React.ReactNode[];
}

export function Wrapper({ children }: IWrapperProps) {
  return <div className={styles['container']}>{children}</div>;
}
